import { Domain, currentUserVar } from "../_graphql/cache/auth";

import { RouteProps } from "./routes";
import _ from "lodash";
import config from "config";
import lodash from "lodash";
import { rankRoutes } from "react-location-rank-routes";

const appDetails = {
    Visal: {
        name: "Visal",
        logo: require("assets/logo.png"),
        tLogo: require("assets/logo-alt.png"),
        hero: require("assets/hero.png"),
    },
};

export const getAppDetails = () => {
    const currentUser = currentUserVar();
    const brokerConfig = currentUser?.employee?.broker_config;
    if (brokerConfig) {
        return {
            name: brokerConfig.broker_company_name,
            logo: appDetails.Visal.logo,
            hero: require("assets/hero.png"),
            tLogo: appDetails.Visal.tLogo,
        };
    }
    return {
        name: appDetails.Visal.name,
        logo: appDetails.Visal.logo,
        hero: appDetails.Visal.hero,
        tLogo: appDetails.Visal.tLogo,
    };
};

export const getDomain = (): Domain => {
    return config.appDomain as Domain;
};

export const withRoutePermissions = (routes: RouteProps[]) => {
    return lodash.filter(routes, () => true);
};
export const withRoutesRoles = (routes: RouteProps[]) => {
    const currentUser = currentUserVar();
    const permissions =
        JSON.parse(atob(currentUser?.broker_role?.privileges || "") || "[]") ||
        [];
    return lodash.filter(routes, (route) =>
        route?.withPermissions && route?.withPermissions.length > 0
            ? lodash.intersection(route?.withPermissions, permissions || [])
                  .length > 0
            : true,
    );
};

export const withRouteDomains = (routes: RouteProps[]) => {
    return lodash.filter(routes, (route) => true);
};

/**
 *
 * @param permissions permissions associated with the current user. pass this if you are using permissions
 * @returns a list of filtered routes
 */
const filterRoutes = () => {
    return lodash.flow([rankRoutes, withRoutesRoles]);
};

export default filterRoutes;
